export const LAST_VISITED_ROUTE_STORAGE_KEY = 'clube:last-visited-route';
